// extracted by mini-css-extract-plugin
module.exports = {"mainBox":"SdgDescription_mainBox__1ntNP","description":"SdgDescription_description__tEvZA","image":"SdgDescription_image__LI9bH"};